import constants from "../constants";

export const isCongreso = (id) => {
  const congreso = constants.congreso.map((items) => items.id);
  return congreso.flat().includes(id);
};
